var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPop2WinRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 30 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1.3,
    y: 7.6,
    transform: "matrix(0.8753 -0.4836 0.4836 0.8753 -1.8962 8.8005)",
    width: 29.6,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.1,
    y: 7.7,
    transform: "matrix(0.4722 -0.8815 0.8815 0.4722 -10.5831 26.17)",
    width: 1,
    height: 28.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3,3.3c-0.2,0-0.4-0.1-0.4-0.3l-0.8-1.6c-0.1-0.2,0-0.5,0.2-0.6c0.2-0.1,0.5,0,0.6,0.2l0.8,1.6c0.1,0.2,0,0.5-0.2,0.6 L15.3,3.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6,25.6c-0.2,0-0.4-0.1-0.4-0.3l-1.3-2.8c-0.1-0.2,0-0.5,0.2-0.6c0.2-0.1,0.5,0,0.6,0.2l1.3,2.8c0.1,0.2,0,0.5-0.2,0.6 L25.6,25.6z M23.1,20.3c-0.2,0-0.4-0.1-0.4-0.3l-1.5-3.3c-0.1-0.2,0-0.5,0.2-0.6c0.2-0.1,0.5,0,0.6,0.2l1.5,3.3 c0.1,0.2,0,0.5-0.2,0.6L23.1,20.3z M20.5,14.6c-0.2,0-0.4-0.1-0.4-0.3L18.5,11c-0.1-0.2,0-0.5,0.2-0.6c0.2-0.1,0.5,0,0.6,0.2 l1.5,3.3c0.1,0.2,0,0.5-0.2,0.6L20.5,14.6z M17.8,8.8c-0.2,0-0.4-0.1-0.4-0.3l-1.5-3.3c-0.1-0.2,0-0.5,0.2-0.6 c0.2-0.1,0.5,0,0.6,0.2l1.5,3.3c0.1,0.2,0,0.5-0.2,0.6L17.8,8.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9,28.4c-0.2,0-0.4-0.1-0.4-0.3l-0.8-1.6c-0.1-0.2,0-0.5,0.2-0.6c0.2-0.1,0.5,0,0.6,0.2l0.8,1.6c0.1,0.2,0,0.5-0.2,0.6 L26.9,28.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5,30l-0.2,0C0,29.8-0.1,29.6,0,29.3l0.8-1.6c0.1-0.2,0.4-0.3,0.6-0.2c0.2,0.1,0.3,0.4,0.2,0.6l-0.8,1.6 C0.8,29.9,0.7,30,0.5,30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.4,25.9l-0.2,0c-0.2-0.1-0.3-0.4-0.2-0.6l1.7-3.5c0.1-0.2,0.4-0.3,0.6-0.2c0.2,0.1,0.3,0.4,0.2,0.6l-1.7,3.5 C2.8,25.8,2.6,25.9,2.4,25.9z M5.3,19.7l-0.2,0c-0.2-0.1-0.3-0.4-0.2-0.6l1.7-3.5c0.1-0.2,0.4-0.3,0.6-0.2c0.2,0.1,0.3,0.4,0.2,0.6 l-1.7,3.5C5.7,19.6,5.5,19.7,5.3,19.7z M8.2,13.5l-0.2,0c-0.2-0.1-0.3-0.4-0.2-0.6l1.7-3.5C9.5,9.1,9.8,9,10.1,9.1 c0.2,0.1,0.3,0.4,0.2,0.6l-1.7,3.5C8.6,13.4,8.4,13.5,8.2,13.5z M11.1,7.3l-0.2,0c-0.2-0.1-0.3-0.4-0.2-0.6l1.4-3.1 c0.1-0.2,0.4-0.3,0.6-0.2C13,3.4,13.1,3.7,13,4l-1.4,3.1C11.5,7.2,11.3,7.3,11.1,7.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1,3l-0.2,0c-0.2-0.1-0.3-0.4-0.2-0.6l0.8-1.6c0.1-0.2,0.4-0.3,0.6-0.2c0.2,0.1,0.3,0.4,0.2,0.6l-0.8,1.6 C13.5,2.9,13.3,3,13.1,3z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.9,
    y: 11.2,
    width: 3.6,
    height: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,29.8H0.2V0H30V29.8z M1.1,28.9H29V1H1.1V28.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26,25.9H3.6v-22H26V25.9z M4.5,25h20.6V4.8H4.5V25z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPop2WinRight);
export default __webpack_public_path__ + "static/media/pop_2win_right.77132450d9f1dffe0cbaa823c98c9085.svg";
export { ForwardRef as ReactComponent };